<div mat-dialog-title>
    {{'Skill Ranking'| translate}}
    <span class="float-right pointer" (click)="close()">
        <i class="fa fa-times close-btn "></i>
    </span>
    <!-- <span style="float: right;" (click)="close()" ><mat-icon>close</mat-icon>  </span> -->


</div>
<div mat-dialog-content>
    <div class="row">
        <div class="col-md-12" *ngIf="this.data && this.data.enableSkill">
            <tm-multi-select [options]="skillList" [form_group]="skillForm" form_control="keySkills"
                title_property="title" id_property="skillCode" float_label="always" (selected_obj)="loadSkills($event)"
                [label]="'JOB_POSTING.primary_skills' | translate" [data]="skillForm.value.keySkills"
                [placeholder]="'< - - Select - - >' | translate" [suffix_btn_icon]="'fa-ellipsis-h'"
                [addFunc]="manageKeySkillsRef">
            </tm-multi-select>
        </div>
        <div class="tm-data-table col-md-12 table-responsive"
            style="height: calc(100vh - 300px) !important; overflow: auto; min-height: 200px;">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Skill</th>
                        <th>Rank</th>
                        <th>Experience (Years) </th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="type==1">
                        <tr *ngFor="let item of options;let i = index">
                            <td style="width: 30%;" [title]="item.title">
                                <span class="line-1">
                                    {{item.title}}
                                </span>

                            </td>
                            <td style="width: 30%;">
                                <mat-slider (change)="detectChanges($event)"
                                    [matTooltip]=" item.skillLevel ==1? ('CONFIG.learner'|translate) :item.skillLevel==2?('CONFIG.beginner'|translate):item.skillLevel==3?('CONFIG.familiar'|translate):item.skillLevel==4?('CONFIG.Independent'|translate):item.skillLevel==5?('CONFIG.expert'|translate):'' "
                                    min="1" max="5" step="1" [value]="item.skillLevel" [(ngModel)]="item.skillLevel">
                                </mat-slider>
                                <span style="font-size: 13px;"> {{item.skillLevel ==1? ('CONFIG.learner'|translate)
                                    :item.skillLevel==2?('CONFIG.beginner'|translate):item.skillLevel==3?('CONFIG.familiar'|translate):item.skillLevel==4?('CONFIG.Independent'|translate):item.skillLevel==5?('CONFIG.expert'|translate):''
                                    }} </span>
                            </td>
                            <td style="width: 10%;"> <input type="number"
                                    style="font-size: 13px;height: 1.5rem !important;" class="form-control"
                                    [placeholder]="'Experience' |translate" [(ngModel)]="item.experience"
                                    (change)="detectChanges($event)"> </td>
                            <td style="width: 10%;">
                                <mat-slide-toggle [(ngModel)]="item.status" (change)="statusChanged($event,i)">
                                    <!-- {{item.status?('CONFIG.active'|translate):('CONFIG.inactive'|translate)}} -->
                                </mat-slide-toggle>
                            </td>
                        </tr>
                    </ng-container>
                    <ng-container *ngIf="type==2 ">
                        <tr *ngFor="let item of options;let i = index">
                            <td style="width: 25%;" [title]="item.title">
                                <span class="line-1">
                                    {{item.title}}
                                </span>

                            </td>
                            <td style="width: 30%;" [style.width]="width">
                                <ngx-slider *ngIf='loaded' [(value)]="item.minSkillLevel"
                                    [(highValue)]="item.maxSkillLevel" [options]="slider_options">
                                </ngx-slider>
                            </td>
                            <td style="width: 25%;">
                                <div class="tm-flex">
                                    <div class="prefix-control" style="width: 45%;">
                                        <input type="number" style="font-size: 13px;height: 1.5rem !important;"
                                            class="form-control" [placeholder]="'Enter experience' |translate"
                                            [(ngModel)]="item.expFrom" (change)="detectChanges($event)">
                                    </div>
                                    <div class="main-control text-center" style="width: 10%;">-</div>
                                    <div class="suffix-control" style="width: 45%;">
                                        <input type="number" style="font-size: 13px;height: 1.5rem !important;"
                                            class="form-control" [placeholder]="'Enter experience' |translate"
                                            [(ngModel)]="item.expTo" (change)="detectChanges($event)">
                                    </div>
                                </div>

                            </td>
                            <td style="width: 20%;">
                                <app-tm-basic-select [form_group]="skillManagerForm"
                                    (selected_obj)="mstatusChanged($event,i)" [form_control]="i.toString()"
                                    [title_property]="'title'" [id_property]="'id'" [options]="statusList"
                                    [design_pattern]="1" [placeholder]="' < - - Select Status - - > '"
                                    [data]="skillManagerForm.get([i.toString()]).value">
                                </app-tm-basic-select>
                            </td>
                        </tr>
                    </ng-container>


                </tbody>
            </table>
        </div>
    </div>

</div>


<mat-dialog-actions>
    <span style="font-size: 13px !important;" id="tm-popup-notification-window"> </span>

    <button style="min-width: 100px;" class="ml-auto  blob-btn-cancel btn mx-1 mx-1 tallite-action" (click)="close()">
        {{ 'BTN.cancel' | translate}}
        <span class="blob-btn-cancel__inner">
            <span class="blob-btn-cancel__blobs">
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
                <span class="blob-btn-cancel__blob"></span>
            </span>
        </span>
    </button>
    <button style="min-width: 100px;" class="blob-btn  btn   mx-1 tallite-action" type="submit" (click)="save()">
        {{ 'Ok' | translate }}
        <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
                <span class="blob-btn__blob"></span>
            </span>
        </span>
    </button>
</mat-dialog-actions>